const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadworksClusterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 176.985,
    cy: 147.787,
    r: 34,
    fill: "#FBE415",
    stroke: "#231F20",
    strokeWidth: 4,
    style: {},
    transform: "matrix(3.928674, 0, 0, 4.261617, -479.629188, -372.860815)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(35, 31, 32)"
    },
    cx: 216.477,
    cy: 316.793,
    rx: 17.247,
    ry: 19.586
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    },
    d: "M 194.362 168.237 L 207.606 279.598 L 225.776 279.602 L 236.16 168.237 L 194.362 168.237 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(0, 0, 0)"
    },
    cx: 336.865,
    cy: 115.019,
    rx: 103.213,
    ry: 107.209
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 255, 255)"
    },
    cx: 337.563,
    cy: 114.763,
    rx: 96.704,
    ry: 100.649
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadworksClusterIcon);
export default __webpack_public_path__ + "static/media/roadworksClusterIcon.a128024ccda6d0a928bef94a5f0f0d65.svg";
export { ForwardRef as ReactComponent };